
const reducer = (state, action) => {
    switch (action.type) {
        case 'USER_SIGN_IN': {
            return { ...state, isLoggedIn: action.payload }
        }

        case 'SET_SIP_STATUS': {
            return { ...state, sipStatus: action.payload }
        }

        case 'SET_MY_SNACK': {
            return { ...state, mySnack: action.payload }
        }

        case 'SET_OUT_BOUND_CALLING': {
            return { ...state, outBoundCalling: action.payload }
        }

        case 'SET_ERROR': {
            return { ...state, errorMsg: action.payload }
        }

        case 'SET_CUSTOMER_PHONE_NUMBER': {
            return { ...state, customerPhoneNumber: action.payload }
        }

        case 'SET_BUTTON': {
            return { ...state, showButton: action.payload }
        }

        case 'SET_CALLER_INFO_MODAL': {
            return { ...state, callerInfoModal: action.payload }
        }
        // Srini - 11/11/24
        case 'SET_SHOW_ERROR': {
            const isErrorVisible = typeof action.payload === 'boolean' ? action.payload : false
            return { ...state, showErr: isErrorVisible }
        }

        case 'SET_CUSTOMER_EMAIL': {
            return { ...state, customerEmail: action.payload }
        }

        case 'SET_CUSTOMER_NAME': {
            return { ...state, customerName: action.payload }
        }

        case 'SET_ANSWER_BUTTON': {
            return { ...state, answerBtn: action.payload }
        }

        case 'SET_CALL_LABEL': {
            return { ...state, callLabel: action.payload }
        }

        case 'SET_CALL_NUMBER': {
            return { ...state, callNumber: action.payload }
        }

        case 'SET_CALL_BUTTON_TYPE': {
            return { ...state, buttonType: action.payload }
        }

        case 'SET_BREAK_MODAL': {
            return { ...state, breakModal: action.payload }
        }

        case 'SET_START_CALL': {
            return { ...state, startCall: action.payload }
        }

        case 'SET_DISPLAY_NUMBER': {
            return { ...state, displayPhoneNumber: action.payload }
        }

        case 'SET_SHOW_TRANSFER': {
            return { ...state, showTransfer: action.payload }
        }

        case 'SET_REFRESH_TOKEN': {
            return { ...state, refreshToken: action.payload }
        }

        case 'SET_CALL_HISTORY': {
            return { ...state, callHistory: action.payload }
        }

        case 'SET_CALL_HISTORY_CHAT': {
            return { ...state, callHistoryChat: action.payload }
        }

        case 'SET_DEP_USER_DATA': {
            return { ...state, userData: action.payload }
        }
        case 'SET_ADDITIONAL_ROLES': {
            return { ...state, additionalRoles: action.payload }
        }

        case 'SET_SHOW_DOMAIN': {
            return { ...state, showDomain: action.payload }
        }

        case 'SET_CALL_DOMAIN': {
            return { ...state, callDomain: action.payload }
        }

        case 'SET_CALL_ACCEPT': {
            return { ...state, callAccept: action.payload }
        }

        case 'SET_TAG_PENDING_ISSUE': {
            return { ...state, tagPreviousIssue: action.payload }
        }

        case 'SET_UID': {
            return { ...state, uId: action.payload }
        }

        case 'SET_CUSTOMER_LOCATION': {
            return { ...state, customerLocation: action.payload }
        }

        case 'SET_CUSTOMER_STATE': {
            return { ...state, customerState: action.payload }
        }

        case 'SET_CUSTOMER_PORTFOLIO': {
            return { ...state, customerPortfolios: action.payload }
        }

        case 'IS_CALL_HANG_UP': {
            return { ...state, isCallHangUp: action.payload }
        }

        case 'SET_AGENTS_STATUS': {
            const noAgentStatus = state.userData.every(ele => ele.hasOwnProperty('agentStatus'))

            if (!noAgentStatus) {
                return {
                    ...state, userData: state.userData.map((ele, i) => {
                        if (ele.email && ele.sip_id == action.payload.caller_number) {
                            return { ...ele, agentStatus: action.payload.data }
                        } else {
                            return ele
                        }
                    })
                }
            } else {
                return state // Do not update userData if any object already has agentStatus
            }
        }

        case 'SET_CALL_UUID': {
            return { ...state, callUuid: action.payload }
        }

        case 'SET_AGENT_HANGUP': {
            return { ...state, agentHangUp: action.payload }
        }

        case 'SET_CUSTOMER_PENDING_TASKS': {
            return { ...state, customerPendingTasks: action.payload }
        }

        case 'ADD_CUSTOMER_PENDING_TASKS': {
            return { ...state, customerPendingTasks: [...state.customerPendingTasks, action.payload] }
        }

        case 'UPDATE_CUSTOMER_PENDING_TASKS': {
            const { uid, newTask } = action.payload
            return {
                ...state,
                customerPendingTasks: state.customerPendingTasks.map(customer => {
                    if (customer.uid === uid) {
                        return {
                            ...customer,
                            task: [...customer.task, newTask] 
                        }
                    }
                    return customer
                })
            }
        }
        case 'REMOVE_CUSTOMER_PENDING_TASKS': {
            return { ...state, customerPendingTasks: state.customerPendingTasks.filter(ele => ele.uid !== action.payload) }
        }

        case 'SET_CALL_TIMER': {
            return { ...state, timer: state.timer + 1 }
        }

        case 'SET_CALL_TIMER_RESET': {
            return { ...state, timer: action.payload }
        }

        case 'SET_IS_CALL_ACTIVE': {
            return { ...state, isCallActive: action.payload }
        }

        case 'SET_CALL_DURATION': {
            return { ...state, callDuration: action.payload }
        }
        case 'SET_CALL_LOGS': {
            return { ...state, callLogs: action.payload }
        }

        case 'SET_CALL_ICON_TOGGLE': {
            return { ...state, callIconToggle: action.payload }
        }

        case 'SET_AGENT_PUBLISH_STATS': {
            return { ...state, agentPublishStatus: action.payload }
        }
        // Dev Srini 25/10/24
        case 'SET_SIP_REG_STATS_MSG': {
            return { ...state, sipRegStsMsg: action.payload }
        }

        case 'SET_SOC_STATS_MSG': {
            return { ...state, socStsMsg: action.payload }
        }

        case 'SET_TOKEN_VAL': {
            return { ...state, tokenValid: action.payload }
        }

        case 'SET_IN_BOUND': {
            return { ...state, inBound: action.payload }
        }
        // srini - 28/11/24
        case 'SET_CLIENT_ID': {
            return { ...state, clientId: action.payload }
        }
        // srini - 28/11/24
        case 'SET_REF_CODE': {
            return { ...state, clientRefCode: action.payload }
        }
        // FAQs state updates - srini - 09/05/25
        case 'SET_FAQ_CATEGORIES': {
            return { ...state, faqCategories: action.payload}
        }

        case 'ADD_FAQ_CATEGORY': {
            return {
                ...state,
                faqCategories: [...state.faqCategories, action.payload]
            };
        }

        case 'UPDATE_FAQ_CATEGORY': {
            return {
                ...state,
                faqCategories: state.faqCategories.map(item =>
                    item.id === action.payload.id ? { ...item, ...action.payload } : item
                )
            }
        }

        case 'DELETE_FAQ_CATEGORY': {
            return {
                ...state,
                faqCategories: state.faqCategories.filter(item => item.id !== action.payload.id)
            }
        }

        case 'SET_FAQ_SUB_CATEGORIES': {
            return { ...state, faqSubCategories: action.payload}
        }

        case 'ADD_FAQ_SUB_CATEGORY': {
            return {
                ...state,
                faqSubCategories: [...state.faqSubCategories, action.payload]
            };
        }

        case 'UPDATE_FAQ_SUB_CATEGORY': {
            return {
                ...state,
                faqSubCategories: state.faqSubCategories.map(item =>
                    item.id === action.payload.id ? { ...item, ...action.payload } : item
                )
            }
        }

        case 'DELETE_FAQ_SUB_CATEGORY': {
            return {
                ...state,
                faqSubCategories: state.faqSubCategories.filter(item => item.id !== action.payload.id)
            }
        }

        case 'SET_FAQS': {
            return { ...state, faqs: action.payload }
        }

        case 'ADD_FAQ': {
            return {
                ...state,
                faqs: [...state.faqs, action.payload]
            };
        }

        case 'UPDATE_FAQ': {
            return {
                ...state,
                faqs: state.faqs.map(faq => 
                    faq.id === action.payload.id ? { ...faq, ...action.payload } : faq
                )
            };
        }

        case 'DELETE_FAQ': {
            return {
                ...state,
                faqs: state.faqs.filter(faq => faq.id !== action.payload.id)
            }
        }

        case 'SET_FAQ_TAGS': {
            return { ...state, faqTags: action.payload}
        }

        case 'ADD_FAQ_TAG': {
            return {
                ...state,
                faqTags: [...state.faqTags, action.payload]
            };
        }

        default: {
            return { ...state }
        }
    }
}

export default reducer